import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  selector: 'app-node-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./node-create.component.scss']
})
export class NodeCreateComponent extends BaseFormComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'node';
  }

}
